module.exports = __webpack_public_path__ + "img/zoom-column.bd24c342.jpg";